/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

const ScrollableDiv = ({
  border,
  className="",
  style,
  children,
  hideScroll = false,
  noScroll = false,
  innerRef
}) => {
  if (noScroll) {
    return (
      <div className={className}>
        {children}
      </div>
    );
  }

  const borderShow = "1px solid #C2C6C8";
  let topBorderClass = "",
      bottomBorderClass = "";
  if (border) {
    switch (border) {
      case "top": topBorderClass = borderShow; break;
      case "bottom": bottomBorderClass = borderShow; break;
      default:
        topBorderClass = borderShow;
        bottomBorderClass = borderShow;
    }
  }

  return (
    <div className="flex-dynamic" ref={innerRef}>
      <div style={{
        minHeight: "100%",
        height: "100%",
        maxHeight: "0px",
        display: "flex",
        flexDirection: "column",
        borderTop: topBorderClass,
        borderBottom: bottomBorderClass,
      }}>
        <div style={{
          minHeight: "100%",
          height: "100%",
          maxHeight: "0px",
          display: "inline-block",
          overflowY: hideScroll ? "auto" : "scroll",
          overflowX: "hidden"
        }}>
          <div className={className} style={style}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScrollableDiv;
